import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  mounted() {
    if (this.$store.state.isMobile) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.initScrollTrigger()
        }, 800)
      })
    }
  },

  methods: {
    initScrollTrigger() {
      this.$nextTick(() => {
        this.$el.querySelectorAll('[data-scroll]').forEach((el) => {
          const target = el.getAttribute('data-scroll-target') || null
          const trigger = target ? document.querySelector(`${target}`) : el
          const start =
            el.getAttribute('data-scroll-position') === 'top'
              ? 'top top'
              : 'top bottom'
          const direction =
            el.getAttribute('data-scroll-direction') || 'vertical'
          const speed = el.getAttribute('data-scroll-speed') || 1

          const x = direction === 'horizontal' ? -80 * speed : 0
          const y = direction === 'vertical' ? 40 * speed : 0

          gsap.to(el, {
            x,
            y,
            duration: 1,
            delay: 0.05,
            ease: 'none',
            scrollTrigger: {
              trigger,
              start,
              // end: 'top 300px',
              scrub: true,
              markers: false
            }
          })
        })
      })
    }
  },

  destroyed() {
    let triggers = ScrollTrigger.getAll()
    triggers.forEach((trigger) => {
      trigger.kill()
    })
  }
}
